import { render } from "./MediaControls.vue?vue&type=template&id=2bf52854&scoped=true"
import script from "./MediaControls.vue?vue&type=script&lang=js"
export * from "./MediaControls.vue?vue&type=script&lang=js"

import "./MediaControls.vue?vue&type=style&index=0&id=2bf52854&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf52854"]])

export default __exports__